<template>
 <v-navigation-drawer
    v-model="$store.state.drawer"
    absolute
    temporary
  >
    <v-list class="pa-1">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <img src="https://pawtocol.com/images/footer_logo.svg">
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Choose a Data Set Below</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list class="pt-0" dense>
      <v-divider></v-divider>

      <v-list-tile
        v-for="item in items"
        :key="item.title"
        :class="{ active: $store.state.pageName == item.title }"
        @click="$store.state.pageName = item.title, $store.state.drawer = !$store.state.drawer"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      items: [
          { title: 'Revenue Sources', icon: 'device_hub' },
          { title: 'Yearly Cost Breakdown', icon: 'linear_scale' },
          { title: 'Cost By Month', icon: 'timeline' },
          { title: 'Break Even Analysis', icon: 'equalizer' },
          { title: 'Opportunity Size', icon: 'pie_chart' },
          { title: 'Summary', icon: 'dashboard' }
      ]
    }
  }
}    
</script>

<style>
.active {
    background: #26A69A;
    color: #fff;
}
.active i {
    color: #fff !important;
}
.v-avatar {
  background: #FF6434
}
.v-avatar img {
  padding: 5px;
}
</style>